import { tabs } from '../../../../../../views/dashboard/company/CompanyDashboard';

export default {
  title: 'Dashboard',
  tabs: {
    [tabs.general]: 'Algemeen',
    [tabs.overview]: 'Overzicht',
    [tabs.orders]: 'Bestellingen per bron',
    [tabs.google]: 'Google',
    [tabs.customers]: 'Klanten',
    [tabs.order_conversion]: 'Bestelconversie',
    [tabs.mobile_app]: 'Mobiele app',
  },
  date_range: {
    this_month: 'Deze maand',
    last_month: 'Vorige maand',
    last_week: 'Vorige week',
    this_week: 'Deze week',
    this_year: 'Dit jaar',
    last_year: 'Vorig jaar',
    today: 'Vandaag',
    yesterday: 'Gisteren',
    all: 'Alle',
  },
  buttons: {
    view_key_info: 'Kerninformatie bekijken',
  },
  empty_franchise: {
    description: 'Dit merk heeft nog geen restaurant. Kies een ander merk in het menu om de cijfers te zien.',
  },
};
